// Deterministic "auto current-event" for the premium TV boards (TEST only).
//
// The bug this fixes: an empty "2026 Four-Ball Qualifying (TEST)" event (stage
// 'qualifying', no flights, but the NEWEST createdAt) was hijacking every board
// over the live 62nd Annual (stage 'active', a full flight of 8 teams), because
// the old auto-pick just took the most-recent open tournament.
//
// This ranks every OPEN tournament by, in order:
//   1. board stage — a qualifying/registration event is NEVER board-worthy, so
//      it can't win while a real tournament exists (protects even if the flights
//      node can't be read for some reason);
//   2. has real board data — a flight with at least one team;
//   3. real over demo;
//   4. most-recent;
//   5. id — a STABLE tiebreak.
// → the same event every render (no oscillation, no revert) and the empty
// qualifying event always ranks last.
export function pickPremiumCurrentEventId(all) {
  const open = Object.entries(all || {}).filter(([, v]) => v?.info?.status !== 'closed')
  const isBoardStage = (v) => {
    const s = v?.info?.stage
    return s !== 'qualifying' && s !== 'registration'
  }
  const hasFlights = (v) =>
    Object.values(v?.flights || {}).some((f) => f && Object.keys(f.teams || {}).length > 0)
  const rank = ([, v]) => [
    isBoardStage(v) ? 1 : 0,
    hasFlights(v) ? 1 : 0,
    v?.info?.isDemo ? 0 : 1,
    v?.info?.createdAt || v?.info?.demoCreatedAt || 0,
  ]
  const sorted = open.slice().sort((a, b) => {
    const ra = rank(a)
    const rb = rank(b)
    for (let i = 0; i < ra.length; i++) if (rb[i] !== ra[i]) return rb[i] - ra[i]
    return a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0
  })
  return sorted[0]?.[0] || null
}
